import axios from "axios";
const instance = axios.create({
baseURL: "https://react-my-burger-7a1c7-default-rtdb.firebaseio.com/"
});

export default instance;
